import type {EventsContainerSliceDefaultPrimary} from 'prismicio-types'
import {useMemo} from 'react'

type LabelGroups = {
  emptyState: EventsContainerSliceDefaultPrimary['labels_empty_state']
  filters: EventsContainerSliceDefaultPrimary['labels_filters']
  cards: EventsContainerSliceDefaultPrimary['labels_cards']
}

export const useEventLabels = (labelGroups: LabelGroups) =>
  useMemo(() => {
    const getLabels = <T>(group: T[] | null | undefined): T | null => group?.[0] || null

    const emptyState = getLabels(labelGroups.emptyState)
    const filters = getLabels(labelGroups.filters)
    const cards = getLabels(labelGroups.cards)

    return {
      emptyState: {
        sectionTitleTemplate: emptyState?.section_title_template || '{eventType} Events',
        successTitle: emptyState?.success_title || 'Thank you for subscribing!',
        successDescriptionTemplate:
          emptyState?.success_description_template || "You'll be the first to know about upcoming {eventType} events.",
        privacyError: emptyState?.privacy_error || 'Please accept the privacy policy',
        subscribeFallback: emptyState?.subscribe_fallback || 'Subscribe',
      },
      filters: {
        allFilter: filters?.all_filter || 'All',
        hostedByLabel: filters?.hosted_by_label || 'Hosted by',
        hostedByMoss: filters?.hosted_by_moss || 'Hosted by Moss',
        partnerEvent: filters?.partner_event || 'Partner Event',
        allEvents: filters?.all_events || 'All Events',
        searchModalTitle: filters?.search_modal_title || 'Search Events',
        searchPlaceholder: filters?.search_placeholder || 'Search by title, description, or speaker...',
        searchResultsTemplate: filters?.search_results_template || 'Found {count} events',
      },
      cards: {
        watchButton: cards?.watch_button || 'WATCH',
        registerButton: cards?.register_button || 'REGISTER',
      },
    }
  }, [labelGroups])
